import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DevolutivaService } from 'src/app/shared/api/licencas/devolutiva.service';
import { ContainerPadraoModule } from "src/app/shared/components/container-padrao/container-padrao.module";
import { LoaderPageModule } from "src/app/shared/components/loader-page/loader-page.module";
import { DevolutivaRoutingModule } from './devolutiva-routing.module';
import { DevolutivaComponent } from './devolutiva.component';
import { SafeHtmlDevolutivaPipe } from './safeHtmlDevolutivaPipe';


@NgModule({
  declarations: [
    DevolutivaComponent,
    SafeHtmlDevolutivaPipe
  ],
  imports: [
    CommonModule,
    DevolutivaRoutingModule,
    ContainerPadraoModule,
    LoaderPageModule
],
  providers: [SafeHtmlDevolutivaPipe, DevolutivaService]
})
export class DevolutivaModule { }
